import { useOutsideClick } from "../../utils/hooks";
import { Dialog, Transition } from "@headlessui/react";
import React, { ReactNode, useRef } from "react";
import { Fragment } from "react";

interface Props {
  modalVisible: boolean;
  setModalVisible: (bool: boolean) => void;
  children: ReactNode;
  additionalClassNames?: string;
  background?: boolean;
  border?: boolean;
  width?: string;
  alignment?: string;
  padding?: string;
  margin?: string;
}

export default function ModalShadow({ modalVisible, setModalVisible, children }: Props): JSX.Element {
  const modalRef = useRef(null);
  useOutsideClick(modalRef, () => {
    setModalVisible(false);
  });

  return (
    <Transition.Root show={modalVisible} as={Fragment}>
      <Dialog as="div" static className="fixed z-50 inset-0 overflow-y-auto" open={modalVisible} onClose={setModalVisible}>
        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-cool-gray-400/25 backdrop-blur-md transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="w-full h-full flex items-center justify-center" ref={modalRef}>
              {children}
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
